var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CourseName',{attrs:{"courseName":_vm.courseBaseData.name,"brief":_vm.courseBaseData.brief}}),_c('CoursePeriod',{attrs:{"courseBaseData":_vm.courseBaseData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }